import ABCyaPhaser from '@abcya/abcya_phaser';
import SoundAssetKeys from './SoundAssetKeys';
import Phaser from 'phaser';

/** @type {Phaser.Sound.HTML5AudioSound} */
let titleJingle = null;

/**
 * 
 * @param {Phaser.Scene} scene 
 */
export function setup(scene) {
  titleJingle = ABCyaPhaser.Audio.createSound(scene);
}

/**
 * 
 * @param {Phaser.Scene} scene you only need to pass in the scene if you want the fade to occur
 * @param {number} fade 
 * @returns 
 */
export function playTitleJingle(scene, fade = 0) {
  if (!titleJingle.isPlaying)titleJingle.play('Jingle',{ loop: true, volume: scene !== null && scene !== undefined && fade > 0 ? 0 : 1 });

  if (scene !== null && scene !== undefined && fade > 0) {
    scene?.tweens.killTweensOf(titleJingle);
    scene.tweens.add({ targets: titleJingle, duration: fade, props: { volume: 1 }, ease: Phaser.Math.Easing.Quadratic.Out });
  }
}

/**
 * 
 * @param {Phaser.Scene} scene you only need to pass in the scene if you want the fade to occur
 * @param {number} fade 
 * @returns 
 */
export function stopTitleJingle(scene, fade = 0) {
  if (!titleJingle.isPlaying) return;

  if (scene !== null && scene !== undefined && fade > 0) {
    scene.tweens.killTweensOf(titleJingle);
    scene.tweens.add({ targets: titleJingle, duration: fade, props: { volume: 0 }, ease: Phaser.Math.Easing.Quadratic.In, onComplete: () => titleJingle.stop() });
  }
  else {
    titleJingle.stop();
  }
}

export function fadeMusicDown(scene, value = 0) {
  scene.tweens.killTweensOf(titleJingle);
  scene.tweens.add({ targets: titleJingle, duration: 800, props: { volume: value }, ease: Phaser.Math.Easing.Linear });
}

export function fadeMusicUp(scene, value = 1) {
  scene.tweens.killTweensOf(titleJingle);
  scene.tweens.add({ targets: titleJingle, duration: 800, props: { volume: value }, ease: Phaser.Math.Easing.Linear });
}